export const getRelativeClickPosition = (e) => {
  const node = e.target;
  const rect = node.getBoundingClientRect();
  const x = e.clientX - rect.left;
  const y = e.clientY - rect.top;
  return [Math.floor(x), Math.floor(y)];
};
